import React, { useEffect, useRef, useState } from "react";
import axios from "../../api";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Card, Grid, IconButton, Typography } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface Media {
  file_url: string;
  file_name: string;
  multimedia_id: number;
  media_stage: string | null;
}
export default function ViewTicketMultimedia() {
  const { id } = useParams();
  const [media, setMedia] = useState<Media[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const fetchedIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!id || fetchedIdRef.current === id) return;
    fetchedIdRef.current = id;
    const loadTicket = async () => {
      try {
        const res = await axios.get(`/tickets/${id}`);
        const ticket = res?.data?.list;
        const raw = ticket?.multimedia || [];
        const deduped = raw.filter(
          (m: Media, i: number, arr: Media[]) =>
            arr.findIndex((x) => x.multimedia_id === m.multimedia_id) === i
        );
        setMedia(deduped);
      } catch (err) {
        console.error("Error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadTicket();
    return () => {
      fetchedIdRef.current = undefined;
    };
  }, [id]);
  const handleMediaOpen = (fileName: string) => {
    const url = `${process.env.REACT_APP_CLOUD_FRONT_URL}/${fileName}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  if (loading) return <Typography>Loading...</Typography>;
  const employeeMedia =
    media?.filter((media) => media.media_stage !== null) || [];
  const preUploads = employeeMedia.filter((m) => m.media_stage === "pre");
  const postUploads = employeeMedia.filter((m) => m.media_stage === "post");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        className="view-ticket"
        style={{
          padding: "24px",
          width: "100%",
          borderRadius: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          display={"flex"}
          justifyContent={"center"}
          className="view-ticket-title"
        >
          <IconButton className="back-btn">
            <ArrowBackIcon onClick={() => navigate("/admin/tickets-list")} />
          </IconButton>
          <Typography variant="h5" gutterBottom>
            Ticket Details
          </Typography>
        </Grid>
        <Box sx={{ p: 3 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Customer Media
          </Typography>

          {media.filter((m) => m.media_stage === null).length === 0 ? (
            <Typography>No media found for this ticket.</Typography>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                gap: 2,
              }}
            >
              {media
                .filter((m) => m.media_stage === null)
                .map((img) => (
                  <Box key={img.multimedia_id}>
                    <div className="media-container view-media">
                      <button
                        type="button"
                        onClick={() => handleMediaOpen(img?.file_name)}
                        style={{
                          all: "unset", // removes default button styles
                          cursor: "pointer",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_CLOUD_FRONT_URL}/${img.file_name}`}
                          alt={`media-${img.multimedia_id}`}
                          loading="lazy"
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                            borderRadius: "10px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                          }}
                        />
                      </button>
                    </div>
                  </Box>
                ))}
            </Box>
          )}
        </Box>
        <Box sx={{ p: 3 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Employee PreUpload Media
          </Typography>

          {preUploads.length === 0 ? (
            <Typography>No media found for this ticket.</Typography>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                gap: 2,
              }}
            >
              {preUploads.map((img) => (
                <Box key={img.multimedia_id}>
                  <div className="media-container view-media">
                    <button
                      type="button"
                      onClick={() => handleMediaOpen(img?.file_name)}
                      style={{
                        all: "unset", // removes default button styles
                        cursor: "pointer",
                        display: "block",
                        width: "100%",
                      }}
                    >
                      <img
                        src={`${process.env.REACT_APP_CLOUD_FRONT_URL}/${img.file_name}`}
                        alt={`media-${img.multimedia_id}`}
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          borderRadius: "10px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                        }}
                      />
                    </button>
                  </div>
                </Box>
              ))}
            </Box>
          )}
        </Box>
        <Box sx={{ p: 3 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            Employee PostUpload Media
          </Typography>

          {postUploads.length === 0 ? (
            <Typography>No media found for this ticket.</Typography>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                gap: 2,
              }}
            >
              {postUploads.map((img) => (
                <Box key={img.multimedia_id}>
                  <div className="media-container view-media">
                    <button
                      type="button"
                      onClick={() => handleMediaOpen(img?.file_name)}
                      style={{
                        all: "unset", // removes default button styles
                        cursor: "pointer",
                        display: "block",
                        width: "100%",
                      }}
                    >
                      <img
                        src={`${process.env.REACT_APP_CLOUD_FRONT_URL}/${img.file_name}`}
                        alt={`media-${img.multimedia_id}`}
                        loading="lazy"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          borderRadius: "10px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                        }}
                      />
                    </button>
                  </div>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Card>
    </DashboardLayout>
  );
}
